<script>
    export let color = "warning";
</script>

<i class="bi bi-record-circle text-{color} blink-star px-0 mx-0"></i>

<style>
    .blink-star {
        animation: blink 1s infinite;
    }

    @keyframes blink {
        0%,
        100% {
            opacity: 1;
        }
        50% {
            opacity: 0.2;
        }
    }
</style>
